/* NP Header behaviors: shrink-on-scroll big logo, transparent-over-hero, drawer */
(function () {
  'use strict';

  function init() {
    var wrapper = document.querySelector('[data-np-header]');
    if (!wrapper || wrapper.dataset.npInit) return;
    wrapper.dataset.npInit = '1';

    var hasBigLogo = wrapper.classList.contains('np-has-big-logo');
    // sticky + overlay classes go on the Shopify section element — it is a
    // direct child of the page flow, so position:sticky actually sticks there
    var sectionEl = wrapper.closest('.np-header-section') || wrapper.closest('.shopify-section') || wrapper.parentElement;
    if (wrapper.dataset.sticky === 'true' && sectionEl) sectionEl.classList.add('np-sticky-sec');

    // Transparent overlay mode when the first section requests it
    var heroTarget = document.querySelector('[data-header-version="transparent"], .np-transparent-header-target');
    var overlayMode = false;
    if (heroTarget) {
      var main = document.getElementById('MainContent') || document.querySelector('main');
      if (main) {
        // only if the transparent target is the first rendered section
        var firstSection = main.querySelector('.shopify-section');
        if (firstSection && firstSection.contains(heroTarget)) {
          overlayMode = true;
          wrapper.classList.add('np-overlay');
          if (sectionEl) sectionEl.classList.add('np-overlay-sec');
        }
      }
    }

    function setHeights() {
      var h = wrapper.offsetHeight;
      wrapper.style.setProperty('--np-header-height', h + 'px');
      if (sectionEl) sectionEl.style.setProperty('--np-h-total', h + 'px');
    }
    // the big logo animates its height, so track size continuously — a stale
    // height leaves a gap of page background behind the transparent header
    if (typeof ResizeObserver !== 'undefined') {
      new ResizeObserver(setHeights).observe(wrapper);
    } else {
      setInterval(setHeights, 400);
    }

    var SHRINK_AT = 24;
    var ticking = false;
    function onScroll() {
      if (ticking) return;
      ticking = true;
      requestAnimationFrame(function () {
        ticking = false;
        var y = window.scrollY || 0;
        if (hasBigLogo) {
          var shrunk = y > SHRINK_AT;
          wrapper.classList.toggle('np-shrunk', shrunk);
          wrapper.classList.toggle('np-big-visible', !shrunk);
        }
        if (overlayMode) {
          wrapper.classList.toggle('np-at-top', y <= SHRINK_AT);
        }
      });
    }

    setHeights();
    onScroll();
    if (hasBigLogo) wrapper.classList.toggle('np-big-visible', (window.scrollY || 0) <= SHRINK_AT);
    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', setHeights);

    // Drawer
    var drawer = document.querySelector('[data-np-drawer]');
    function openDrawer() {
      if (!drawer) return;
      drawer.classList.add('is-open');
      drawer.setAttribute('aria-hidden', 'false');
      document.body.classList.add('np-drawer-open');
    }
    function closeDrawer() {
      if (!drawer) return;
      drawer.classList.remove('is-open');
      drawer.setAttribute('aria-hidden', 'true');
      document.body.classList.remove('np-drawer-open');
    }
    document.addEventListener('click', function (e) {
      if (e.target.closest('[data-np-drawer-open]')) {
        e.preventDefault();
        openDrawer();
      } else if (e.target.closest('[data-np-drawer-close]')) {
        e.preventDefault();
        closeDrawer();
      }
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') closeDrawer();
    });

    // Cart count refresh
    function refreshCount() {
      fetch('/cart.js', { headers: { Accept: 'application/json' } })
        .then(function (r) { return r.json(); })
        .then(function (cart) {
          document.querySelectorAll('[data-np-cart-count]').forEach(function (el) {
            el.textContent = cart.item_count;
          });
          document.querySelectorAll('[data-np-cart]').forEach(function (el) {
            el.classList.toggle('np-cart-empty', cart.item_count === 0);
          });
        })
        .catch(function () {});
    }
    document.addEventListener('np:cart:updated', refreshCount);
    window.addEventListener('pageshow', function (e) {
      if (e.persisted) refreshCount();
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
  document.addEventListener('shopify:section:load', init);
})();
